module.exports = __webpack_public_path__ + "r-v3/img/ml_22_01.59d123ad.jpg";